import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-auto w-full bg-primary-950">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-950">
                <i className="ri-leaf-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-50">嫩草影院</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-300">
              嫩草影院专注提供最新电影、电视剧资源与影视资讯，涵盖科幻、悬疑、都市、古装等多种类型，
              帮助影视爱好者快速发现想看的内容，掌握第一手行业动态。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-mail-line', 'ri-share-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-primary-900 text-foreground-200 transition-colors hover:bg-primary-500 hover:text-background-950"
                >
                  <i className={`${icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-100">
              <Link to="/category?type=movie" className="hover:text-primary-400">
                影视导航
              </Link>
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/" className="text-foreground-300 transition-colors hover:text-primary-400">
                  首页推荐
                </Link>
              </li>
              <li>
                <Link
                  to="/category?type=movie"
                  className="text-foreground-300 transition-colors hover:text-primary-400"
                >
                  电影分类
                </Link>
              </li>
              <li>
                <Link
                  to="/category?type=tv"
                  className="text-foreground-300 transition-colors hover:text-primary-400"
                >
                  电视剧分类
                </Link>
              </li>
              <li>
                <Link to="/search?q=热门" className="text-foreground-300 transition-colors hover:text-primary-400">
                  热门搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-100">
              <Link to="/news" className="hover:text-primary-400">
                资讯与帮助
              </Link>
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/news" className="text-foreground-300 transition-colors hover:text-primary-400">
                  影视资讯
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-300 transition-colors hover:text-primary-400">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-300 transition-colors hover:text-primary-400">
                  使用须知
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-300 transition-colors hover:text-primary-400">
                  联系方式
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900 pt-6 text-xs text-foreground-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 嫩草影院 nencao-cinema.com · 本站内容均为演示示例，仅供学习交流使用。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span className="whitespace-nowrap">友情提示：请支持正版影视</span>
            <span className="whitespace-nowrap">客服邮箱：support@nencao-demo.com</span>
          </p>
        </div>
      </div>
    </footer>
  );
}